/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

// Component imports
import VariablesList from '../VariablesList';

// Misc imports
import { useFetchEventIdInteractionVariablesQuery } from '../../../store/interactionMetadata/interactionMetadataApi';
import { isEmptyObject } from '../../../utils/is/isEmptyObject';

const SessionInteractionVariablesTab = ({
  selectedChatSessionMessage
}) => {

  const { orgId } = useParams();

  const { data: interactionVariables, isLoading: isLoadingInteractionVariables } = useFetchEventIdInteractionVariablesQuery({ orgId, eventId: selectedChatSessionMessage?.id }, { skip: isEmptyObject(selectedChatSessionMessage) });

  return (
    <VariablesList maxHeight={590} variables={interactionVariables} isLoading={isLoadingInteractionVariables}/>
  );
};

SessionInteractionVariablesTab.propTypes = {
  selectedChatSessionMessage: PropTypes.object
};

export default SessionInteractionVariablesTab;
